module.exports = __webpack_public_path__ + "img/politica-comercial.6c01fda5.svg";